import type { Ref } from 'vue';
import { computed, nextTick, ref } from 'vue';
import { useRoute } from 'vue-router';
import { createGlobalState } from '@vueuse/core';
import _ from 'lodash';
import type { HistoryItem } from '../types';
import { getHistoryList } from '../infrastructure/api-functions';
import { useCachedCollapse } from './use-cached-collapse';
import { create } from '@eureka/utils/deferred';

export const useNavBarState = createGlobalState(
    () => {
        const { load, save } = useCachedCollapse();

        const collapse = ref(load());

        const shouldSave = ref(true);

        const loading = ref(true);

        const route = useRoute();
        const listDeferred = create<HistoryItem[]>();

        const historyList: Ref<HistoryItem[]> = ref([]);

        const currentDetailId = computed(() => {
            return route.params?.seek_id || route.params?.board_id || route.params?.projectId || route.params?.fmea_id || route.query?.board_id;
        })

        const currentRoute = computed(() => {
            return route.path + currentDetailId.value;
        })

        const routeQuery = computed(() => { return route.query });

        const routeName = computed(() => {
            return route.name;
        })
        function updateNavStatus(value: boolean, save = true) {
            collapse.value = value;
            shouldSave.value = save;
            // 确保在下一个 DOM 更新周期中重新启用保存
            nextTick(() => {
                shouldSave.value = true;
            });
        }

        function updateHistory(list) {
            historyList.value = list;
        }

        function queryList(filters: string[] = []) {
            loading.value = true;
            getHistoryList(filters).then((res) => {
                historyList.value = res.records;
                loading.value = false;
                listDeferred.resolve(historyList.value)
            });
        }

        async function getActiveHistoryItem() {
            const list = loading.value ? await listDeferred.promise : historyList.value;
            const activeHistoryItem = _.find(list, (item) => item.id === currentDetailId.value);
            return activeHistoryItem;
        }

        return {
            collapse,
            loading,
            getActiveHistoryItem,
            historyList,
            currentDetailId,
            routeName,
            currentRoute,
            routeQuery,
            updateNavStatus,
            queryList,
            updateHistory,
            save,
            shouldSave,
        }
    }
)
